import { Resources } from '@ragu-components/ord-resources';

import { HuntingGroupList } from './HuntingGroupList';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { HuntingGroup } from '@ragu-components/ord-types';

export const huntingGroupsResource: OrdResourceProps = {
  key: Resources.hunting_groups,
  name: Resources.hunting_groups,
  list: <HuntingGroupList />,
  hasShow: true,
  options: {},
  recordRepresentation: (record: HuntingGroup): string => record.name,
};
